import { useQuery } from '@tanstack/react-query';
import { PunchClock, PunchClockAction } from '@models/punchClock.model';
import { punchClockService } from '@services/punchClock';

export const PUNCH_CLOCKS_BY_USER_KEY = ['punchClocks', 'byUser'];

interface UsePunchClocksByUserOptions {
  enabled?: boolean;
}

export const usePunchClocksByUser = (
  userId: string | null | undefined,
  action: PunchClockAction | null,
  options: UsePunchClocksByUserOptions = {},
) => {
  const { enabled = true } = options;
  return useQuery<PunchClock[], Error>({
    queryKey: [...PUNCH_CLOCKS_BY_USER_KEY, userId ?? null, action ?? 'ALL'],
    queryFn: async () => {
      if (!userId) return [];
      return await punchClockService.getPunchClocksByUser(userId, action);
    },
    enabled: enabled && !!userId,
  });
};

export default usePunchClocksByUser;
